import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import Select from "react-virtualized-select";

const BasicAddressData = (props) => {
  const address = props.address;
  let countryList;
  if (props.disableCro) {
    countryList = props.parentState.countryList.filter(
      (element) => element.sifDrzave != 191
    );
  } else {
    countryList = props.parentState.countryList;
  }
  const { districtList } = props.parentState;
  const selectStyle = { borderColor: "red" };

  return (
    <div className="form-group">
      <Row>
        <Col>
          <label htmlFor={props.id}>Država</label>
          <Select
            noResultsText={"Nema rezultata"}
            style={
              (props.disableCro &&
                address.sifDrzave.length < 1 &&
                selectStyle) ||
              null
            }
            disabled={props.disabled || props.hack}
            className="select-address"
            placeholder="Odaberi državu"
            options={countryList}
            onChange={(selectValue) =>
              props.setCountryAutocompleteHandler(selectValue, {
                formGroup: props.objData.group,
                value: "country",
                code: "sifDrzave",
                id: props.id || null,
              })
            }
            id={`reviser-registration-country-select${props.id}-${props.hackId}`}
            labelKey="nazivKratki"
            valueKey="sifDrzave"
            value={address.sifDrzave}
            title="Država"
          />

          <br></br>
        </Col>
        <Col>
          <InputComponent
            required={props.requiredBrPoste}
            style={
              props.requiredBrPoste &&
              props.parentState.error &&
              address.brPoste.length < 1 &&
              "red"
            }
            disabled={props.disabled}
            objData={props.objData}
            name="brPoste"
            id={`br-poste-reviser-registration${props.id}-${props.hackId}`}
            onChange={props.onChange}
            value={address.brPoste}
            controlLabel={"Poštanski broj"}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            required={props.requiredNazNaselja}
            style={
              props.requiredNazNaselja &&
              props.parentState.error &&
              address.nazNaselja.length < 1 &&
              "red"
            }
            disabled={props.disabled}
            objData={props.objData}
            onChange={props.onChange}
            value={address.nazNaselja}
            name="nazNaselja"
            id={`naziv-naselja-address${props.id}-${props.hackId}`}
            controlLabel={"Naziv mjesta"}
          />
        </Col>
        <Col>
          <InputComponent
            required={props.requiredKbr}
            style={
              props.requiredKbr &&
              props.parentState.error &&
              address.ulicaKbr.length < 1 &&
              "red"
            }
            disabled={props.disabled}
            objData={props.objData}
            onChange={props.onChange}
            id={`ulica-kbr-address${props.id}-${props.hackId}`}
            name="ulicaKbr"
            value={address.ulicaKbr}
            controlLabel={"Ulica i kućni broj"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default BasicAddressData;
